import Layout2 from '@/layout/Layout2'
let ja = require('../../common/lang/ja')
let zh = require('../../common/lang/zh-CN')

export default [{
    path: '/shopRoles',
    component: Layout2,
    meta: {
        zhtitle: zh.m.aside.nav.SHOPROLE,
        jatitle: ja.m.aside.nav.SHOPROLE
    },
    children: [{
        path: '',
        name: 'list',
        component: () => import(/* webpackChunkName: "jp.shoproles" */ '@/merchanAdmin/shopRoles/list'),
        meta: {
            zhtitle: zh.m.aside.nav.SHOPROLE,
            jatitle: ja.m.aside.nav.SHOPROLE,
            pername: "admin_storeAdministrator"
        },
    }, {
        path: 'create',
        name: 'create',
        component: () => import(/* webpackChunkName: "jp.shoproles" */ '@/merchanAdmin/shopRoles/detail'),
        meta: {
            zhtitle: zh.m.router.common.CREATE,
            jatitle: ja.m.router.common.CREATE,
            pername: "admin_storeAdministrator"
        },
    }, {
        path: 'detail',
        name: 'detail',
        component: () => import( /* webpackChunkName: "jp.shoproles" */ '@/merchanAdmin/shopRoles/detail'),
        meta: {
            zhtitle: zh.m.router.common.EDIT,
            jatitle: ja.m.router.common.EDIT,
            pername: "admin_storeAdministrator"
        },
    }]
}]
